import { Observable } from 'rxjs';
import { WsSyncLog, WsSyncLogsQuery } from '../interfaces/ws-sync-log.types';

export abstract class WsSyncLogsRepository {
  abstract getLogs(query: WsSyncLogsQuery): Observable<WsSyncLog[]>;
}
